import requests from "./httpService";

const UserServices = {

    getAllUser: async () => {
        return requests.get(`/user`);
    },

    getTodayUser: async () => {
        return requests.get(`/admin/today-customer`);
    },

    getActiveUsers: async () => {
        return requests.get(`/user/active`);
    },

    getState: async () => {
        return requests.get(`/newlocation/states`);
    },
    getCities: async (id) => {
        return requests.get(`/newlocation/cities/${id}`);
    },

    getSubcriptionUsers: async () => {
        return requests.get(`/buymembershipoffer/all-active-subcription-custombar`);
    },

    getSubcriptionAllUsers: async () => {
        return requests.get(`/buymembershipoffer/all-subcription-customber`);
    },

    expireSubcriptionAllUsers: async () => {
        return requests.get(`/buymembershipoffer/all-expired-subcription-custombar`);
    },


    pandingSubcriptionAllUsers: async () => {
        return requests.get(`/buymembershipoffer/pending-subcription-customer`);
    },

    getINActiveUsers: async () => {
        return requests.get(`/user/inactive`);
    },

    getBlockUsers: async () => {
        return requests.get(`/user/block`);
    },


    getAllVendor: async () => {

        return requests.get(`/user/vendor`);
    },

    getregisterVendor: async () => {
        return requests.get(`/user/vendor/register`);
    },

    // addVendors: async () => {
    //     return requests.post(`/user/vendor/create`);
    // },
    addVendor: async (payload) => {
        return requests.post(`/user/vendor/create`, payload);
    },

    getAllActiveVendor: async () => {
        return requests.get(`/user/vendor/active`);
    },

    getAllInActiveVendor: async () => {

        return requests.get(`/user/vendor/inactive`);
    },

    getAllBlockVendor: async () => {
        return requests.get(`/user/vendor/block`);
    },


    approveVendor: async (id, body) => {
        return requests.put(`/user/vendor/approve/${id}`, body);
    },

    getAllUser: async () => {

        return requests.get(`/user`);
    },
    getAllDoctor: async () => {

        return requests.get(`/user?userType=Doctor`);
    },
    updateUser: async (id, body) => {
        return requests.patch(`/user/${id}`, body);
    },
    
    updateUserStatus: async (id, body) => {
        return requests.patch(`/user/updateStatus/${id}`, body);
    },
    userMembershipUpdateStatus: async (id, body) => {
        return requests.patch(`/buymembershipoffer/update-status/${id}`, body);
    },

    updateUserblockStatus: async (id, body) => {
        return requests.patch(`/user/updateBlockStatus/${id}`, body);
    },

    updateVendor: async (id, body) => {

        return requests.patch(`/user/vendor/${id}`, body);
    },

    updateVendorStatus: async (id, body) => {

        return requests.patch(`/user/vendor/updateStatus/${id}`, body);
    },

    updateVenderblockStatus: async (id, body) => {
        return requests.patch(`/user/vendor/updateBlockStatus/${id}`, body);
    },

    getAllVehicle: async () => {
        return requests.get(`/vehical`);
    },

    getContactDetail: async () => {
        return requests.get(`/contact`);
    },

    updateContactDetail: async (id, body) => {
        return requests.patch(`/contact/${id}`, body);
    },


    createHolidayDetail: async (body) => {
        return requests.post(`/holiday-app/holidays`, body);
    },

    getHolidayDetail: async () => {
        return requests.get(`/holiday-app/holidays-admin`);
    },


    updateHolidayDetail: async (id, body) => {
        return requests.patch(`/holiday-app/holidays/${id}`, body);
    },

    deleteUser: async (id) => {

        return requests.delete(`/user/${id}`);
    },
    allordersOfVender: async (id) => {
        return requests.post(`booking/all-orders-Of-Vender/${id}`);
    },
    deleteVendor: async (id) => {

        return requests.delete(`/user/vendor/${id}`);
    },

    assignVerificationToDoctor: async (verificationId, doctorId) => {
        return requests.post('/verification/assign', { verificationId, doctorId });
    },

    getAllVendorAttendance: async (id) => {
        return requests.get(`/user/vendor/attendance/${id}`);
    },

    getUserActivity: async (payload) => {
        return requests.post("/user/userActivity", payload);
    }


}

export default UserServices;